'use es6';

import { createContext } from 'react';

const defaultValue = undefined;

export default createContext(defaultValue);
